<template>
  <div class="agencyContract-table">
    <vxe-grid
      v-if="showTable"
      border
      show-overflow
      resizable
      ref="ruleTable"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :toolbar="isEdit"
      show-footer
      :footer-method="footerMethod"
      :data="productData"
      :edit-rules="editRules"
      :edit-config="editConfig"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :expand-config="{ accordion: true, lazy: true, loadMethod: loadContentMethod }"
      :max-height="$store.state.app.tableHeight"
      @select-change="handleSelectionChange"
    >
      <template v-slot:buttons>
        <vxe-button
          @click="commitProxy()"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('xTable.insert') }}</vxe-button
        >
        <vxe-button
          @click="handleDelete"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('xTable.delete') }}</vxe-button
        >
      </template>
      <vxe-table-column v-if="isEdit" fixed="left" type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column
        type="seq"
        fixed="left"
        width="60"
        :title="$t('contractAgency.productTab.index')"
      ></vxe-table-column>
      <template v-for="(item, index) in columns">
        <template v-if="item.children && item.children.length">
          <vxe-table-column :key="index" :title="item.title" align="center">
            <vxe-table-column
              v-for="(child, index) in item.children"
              :key="index"
              :field="child.field"
              :width="child.width"
              :edit-render="child.editRender"
              :title="child.title"
            >
              <template v-slot:edit="{ row }">
                <template v-if="child.editRender && child.editRender.name == 'ajaxSelect'">
                  <ajax-select
                    v-model="row[child.field]"
                    :apiUrl="child.apiUrl"
                    :apiData="child.apiData"
                    :valueType="child.valueType"
                    @change="(val) => chooseTable(row, child, child.editRender.name)"
                    :valueKey="child.valueKey"
                    :labelKey="child.labelKey"
                  ></ajax-select>
                </template>
                <!--如果是数字输入 且为合同数量-->
                <template
                  v-if="
                    child.editRender &&
                    item.field == 'contrantQuantity' &&
                    child.editRender.name == 'inputNumber'
                  "
                >
                  <input-number
                    v-model="row[child.field]"
                    :max="child.max"
                    :precision="child.precision || 6"
                    :disabled="child.disabled || false"
                    @change="() => handleChangeInput({ row }, item.field)"
                  ></input-number>
                </template>
                <!--如果是数字输入-->
                <template v-else-if="child.editRender && child.editRender.name == 'inputNumber'">
                  <input-number
                    v-model="row[child.field]"
                    :max="child.max"
                    :precision="child.precision || 6"
                    :disabled="child.disabled || false"
                    @change="() => handleChangeInput({ row }, child.field)"
                  ></input-number>
                </template>
                <!--输入框-->
                <template v-if="child.editRender && child.editRender.name == 'ElInput'">
                  <el-input
                    v-model="row[child.field]"
                    :disabled="child.disabled || false"
                  ></el-input>
                </template>
                <template v-if="child.editRender && child.editRender.name == 'default'">
                  {{ row[child.field] }}
                </template>
              </template>
              <template v-slot="{ row }">
                <!--人民币默认只显示人民币-->
                <!--原币本币-->
                <div v-if="row[child.field] && child.label" class="price-col">
                  <div v-if="exchangeRate == 1 && salesExchangeRate == 1">
                    <p
                      v-if="
                        ['purchaseBusinessUnitPrice', 'proxyBusinessUnitPrice'].indexOf(
                          child.field
                        ) == -1
                      "
                      style="line-height: 35px"
                    >
                      {{ $baseRequest.formatTableColumn(row[child.field], $globalVar.aPoint) }}
                    </p>
                    <p
                      v-else-if="
                        ['purchaseBusinessUnitPrice', 'proxyBusinessUnitPrice'].indexOf(
                          child.field
                        ) != -1
                      "
                      style="line-height: 35px"
                    >
                      {{ $baseRequest.formatTableColumn(row[child.field], $globalVar.pPoint) }}
                    </p>
                  </div>
                  <div v-else>
                    <p
                      v-if="
                        ['purchaseBusinessUnitPrice', 'proxyBusinessUnitPrice'].indexOf(
                          child.field
                        ) == -1
                      "
                    >
                      {{ child.label }}
                      {{ $baseRequest.formatTableColumn(row[child.field], $globalVar.aPoint) }}
                    </p>
                    <p
                      v-else-if="
                        ['purchaseBusinessUnitPrice', 'proxyBusinessUnitPrice'].indexOf(
                          child.field
                        ) > -1
                      "
                    >
                      {{ child.label }}
                      {{ $baseRequest.formatTableColumn(row[child.field], $globalVar.pPoint) }}
                    </p>
                    <p
                      v-if="
                        ['purchaseBusinessUnitPrice', 'proxyBusinessUnitPrice'].indexOf(
                          child.field
                        ) == -1
                      "
                    >
                      {{ $t('contractAgency.productTab.localCoin') }}
                      {{
                        $baseRequest.formatTableColumn(
                          row[child.field + 'Local'],
                          $globalVar.aPoint
                        )
                      }}
                    </p>
                    <p
                      v-else-if="
                        ['purchaseBusinessUnitPrice', 'proxyBusinessUnitPrice'].indexOf(
                          child.field
                        ) > -1
                      "
                    >
                      {{ $t('contractAgency.productTab.localCoin') }}
                      {{
                        $baseRequest.formatTableColumn(
                          row[child.field + 'Local'],
                          $globalVar.pPoint
                        )
                      }}
                    </p>
                  </div>
                </div>
                <div
                  v-if="
                    child.editRender && child.editRender.name == 'ajaxSelect' && row[child.field]
                  "
                  >{{ row[child.name] }}</div
                >
                <div v-if="child.editRender && child.editRender.name == 'default'">
                  {{ row[child.field] }}</div
                >
                <div
                  v-if="
                    child.editRender &&
                    child.editRender.name == 'inputNumber' &&
                    (child.field == 'importNormalTariffRate' || child.field == 'taxRefundRate')
                  "
                >
                  {{ row[child.field] }}</div
                >
                <!-- <template v-if="child.editRender && child.editRender.name=='inputNumber'"
                  >{{spliceMoreZero(row[child.field])}}</template> -->
              </template>
            </vxe-table-column>
          </vxe-table-column>
        </template>
        <template v-else>
          <vxe-table-column
            v-if="item.field == 'productDesc' && isExpand"
            :key="index"
            :fixed="item.fixed"
            :width="item.width"
            :title="item.title"
            :class-name="setClassName"
            :edit-render="item.editRender"
            type="expand"
          >
            <template v-slot:content="{ row }">
              <div class="childDataTable">
                <vxe-table
                  resizable
                  :auto-resize="true"
                  border
                  :data="row.childData"
                  :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
                  :valid-config="{ autoPos: true, message: 'inline' }"
                >
                  <vxe-table-column
                    v-for="childs in row.childCols"
                    :key="childs.field"
                    :field="childs.field"
                    :title="childs.title"
                    :edit-render="childs.editRender"
                  >
                    <template v-slot="{ row }">
                      <span v-if="childs.field == 'temporaryPrice'">{{
                        $baseRequest.formatTableColumn(row[childs.field], $globalVar.pPoint)
                      }}</span>
                      <span v-else>{{ row[childs.field] }}</span>
                    </template>
                    <template v-slot:edit="scope">
                      <template
                        v-if="childs.field == 'temporaryPrice' || childs.field == 'productQuantity'"
                      >
                        <input-number
                          :disabled="
                            scope.row.priceIdentityName != '已定价' && scope.row.isUsed == 1
                          "
                          v-model="scope.row[childs.field]"
                          :max="childs.max"
                          :clearable="false"
                          :precision="childs.precision"
                          @blur="(val) => changeTemporaryPrice(val, scope.row, childs.field)"
                        ></input-number>
                      </template>
                    </template>
                  </vxe-table-column>
                </vxe-table>
                <!-- <vxe-grid
                    :columns="row.childCols"
                    :data="row.childData"
                    resizable
                    :auto-resize="true"
                  >
                  </vxe-grid> -->
              </div>
            </template>
            <template v-slot:edit="{ row }">
              <!-- 如果不是商品描述 -->
              <template
                v-if="
                  item.editRender &&
                  item.editRender.name == 'searchTable' &&
                  item.name != 'productDesc'
                "
              >
                <search-table
                  v-model="row[item.field]"
                  :searchType="item.searchType"
                  :isMultiple="true"
                  :currentValue="row[item.name]"
                  :checkRowKeys="[row[item.code]]"
                  @input="() => chooseTable(row, item, item.editRender.name)"
                ></search-table>
              </template>
              <!-- 如果是商品描述 -->
              <template
                v-else-if="
                  item.editRender &&
                  item.editRender.name == 'searchTable' &&
                  item.name == 'productDesc'
                "
              >
                <search-table
                  v-model="row[item.field]"
                  :searchType="item.searchType"
                  :isMultiple="true"
                  :currentValue="row[item.name]"
                  :checkRowKeys="[row[item.code]]"
                  :disabled="
                    (contractStatusList.indexOf(defaultData.contractStatus) != -1
                      ? true
                      : isEdit) && !!row[item.field]
                  "
                  @input="() => chooseTable(row, item, item.editRender.name)"
                ></search-table>
              </template>
              <!--如果是数字输入-->
              <template v-if="item.editRender && item.editRender.name == 'inputNumber'">
                <input-number
                  v-model="row[item.field]"
                  :max="item.max"
                  :precision="item.percision || 6"
                  :disabled="item.disabled || false"
                  @change="() => handleChangeInput({ row }, item.field)"
                ></input-number>
              </template>
              <!--输入框-->
              <template v-if="item.editRender && item.editRender.name == 'ElInput'">
                <el-input v-model="row[item.field]" :disabled="item.disabled || false"></el-input>
              </template>
              <template v-if="item.editRender && item.editRender.name == 'default'">
                {{ row[item.field] }}
              </template>
            </template>
            <template v-slot="{ row }">
              <template v-if="item.editRender && item.editRender.name == 'searchTable'">{{
                row[item.name]
              }}</template>
              <template v-if="item.editRender && item.editRender.name == 'inputNumber'">{{
                toFixedNumber(row[item.field], item.percision == 3 ? 3 : 2)
              }}</template>
              <template
                v-if="
                  item.editRender &&
                  (item.editRender.name == 'ElInput' || item.editRender.name == 'default')
                "
              >
                {{ row[item.field] }}
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column
            v-else
            :key="index"
            :field="item.field"
            :fixed="item.fixed"
            :width="item.width"
            :title="item.title"
            :class-name="setClassName"
            :edit-render="item.editRender"
          >
            <template v-slot:content="{ row }">
              <div class="childDataTable">
                <vxe-grid
                  :columns="row.childCols"
                  :data="row.childData"
                  resizable
                  :auto-resize="true"
                ></vxe-grid>
              </div>
            </template>
            <template v-slot:edit="{ row }">
              <!-- 如果不是商品描述 -->
              <template
                v-if="
                  item.editRender &&
                  item.editRender.name == 'searchTable' &&
                  item.name != 'productDesc'
                "
              >
                <search-table
                  v-model="row[item.field]"
                  :searchType="item.searchType"
                  :isMultiple="true"
                  :currentValue="row[item.name]"
                  :checkRowKeys="[row[item.code]]"
                  @input="() => chooseTable(row, item, item.editRender.name)"
                ></search-table>
              </template>
              <!-- 如果是商品描述 -->
              <template
                v-else-if="
                  item.editRender &&
                  item.editRender.name == 'searchTable' &&
                  item.name == 'productDesc'
                "
              >
                <search-table
                  v-model="row[item.field]"
                  :searchType="item.searchType"
                  :isMultiple="true"
                  :currentValue="row[item.name]"
                  :checkRowKeys="[row[item.code]]"
                  :disabled="
                    !(
                      $route.query.isCopy ||
                      !$route.query.contractNo ||
                      contractStatus == 'ZT06' ||
                      contractStatus == 'ZT05' ||
                      !row[item.field]
                    )
                  "
                  @input="() => chooseTable(row, item, item.editRender.name)"
                ></search-table>
              </template>
              <!--如果是数字输入-->
              <template v-if="item.editRender && item.editRender.name == 'inputNumber'">
                <input-number
                  v-model="row[item.field]"
                  :max="item.max"
                  :precision="item.percision || 6"
                  :disabled="item.disabled || false"
                  @change="() => handleChangeInput({ row }, item.field)"
                ></input-number>
              </template>
              <!--输入框-->
              <template v-if="item.editRender && item.editRender.name == 'ElInput'">
                <el-input v-model="row[item.field]" :disabled="item.disabled || false"></el-input>
              </template>
              <template v-if="item.editRender && item.editRender.name == 'default'">
                {{ row[item.field] }}
              </template>
            </template>
            <template v-slot="{ row }">
              <template v-if="item.editRender && item.editRender.name == 'searchTable'">{{
                row[item.name]
              }}</template>
              <template v-if="item.editRender && item.editRender.name == 'inputNumber'">{{
                toFixedNumber(row[item.field], item.percision == 3 ? 3 : 2)
              }}</template>
              <template
                v-if="
                  item.editRender &&
                  (item.editRender.name == 'ElInput' || item.editRender.name == 'default')
                "
              >
                {{ row[item.field] }}
              </template>
            </template>
          </vxe-table-column>
        </template>
      </template>
    </vxe-grid>
    <el-form class="total-price" label-width="100px">
      <el-row :gutter="10">
        <el-col v-for="(item, index) in totalForm" :key="index" :span="item.text ? 3 : 7">
          <span v-if="item.text">{{ item.title }}</span>
          <el-form-item :label="item.title" v-else>
            <el-input :value="item.value" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import ajaxSelect from '@/components/form-item/ajax-select';
  import searchTable from '@/components/form-item/search-table';
  import inputNumber from '@/components/form-item/input-number';
  import AGENCY_API from '@/api/agencyContract/index';
  // import { calAmount } from '@/common/js/contract-cal';
  import { spliceMoreZero, toFixedNumber } from '@/common/js/util';
  import BASE_API from '@/api/dataBase';
  import goodsPrice from '@/common/mixins/goodsPrice.js';
  import XEUtils from 'xe-utils';
  export default {
    mixins: [goodsPrice],
    props: {
      isEdit: {
        type: Boolean,
        default: true,
      },
      exchangeRate: {
        //采购汇率
        type: [Number, String],
        default: '',
      },
      salesExchangeRate: {
        //销售汇率
        type: [Number, String],
        default: '',
      },
      defaultData: {
        type: Object,
        default: () => {},
      },
      //贸易类型
      defaultBusinessType: {
        type: String,
        default: () => '',
      },
      // 合同状态
      contractStatus: {
        type: String,
        default: () => '',
      },
    },
    components: {
      ajaxSelect,
      searchTable,
      inputNumber,
    },
    data() {
      return {
        showTable: true,
        productData: [], // 商品表格
        editConfig: {},
        allTotal: {}, // 总金额计算
        selectTotal: {}, // 选中小计,
        tradeType: '', //贸易类型
        isExpand:
          ['', 'ZT02', 'ZT05', 'ZT06', 'ZT051', 'ZT061'].indexOf(this.contractStatus) == '-1',
        businessType: this.defaultBusinessType, //业务性质
        addedTaxRateOptions: [], //增值税
        contractStatusList: ['ZT061', 'ZT051'], // 草稿、已驳回 ,修订中，修改已驳回 可以修改"
        amountProps: [
          'contractQuantity',
          'purchaseBusinessUnitPrice',
          'purchaseBusinessTotalAmount',
          'purchaseBusinessTaxAmount',
          'purchaseBusinessPureAmount',
          'proxyBusinessUnitPrice',
          'proxyBusinessTotalAmount',
          'proxyBusinessTaxAmount',
          'proxyBusinessPureAmount',
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      columns() {
        const tenantCode = this.userInfo.tenantCode;
        return [
          // 行项目号
          {
            field: 'contractDetailNo',
            title: this.$t('salePurchase.table.contractDetailNo'),
            width: 100,
            // fixed: 'left',
            editRender: { name: 'default' },
          },
          {
            field: 'productDesc',
            title: this.$t('contractAgency.productTab.productDesc'),
            width: 120,
            editRender: {
              name: 'searchTable',
            },
            name: 'productDesc',
            code: 'productNo',
            getName: 'detailProductDisplayName',
            getCode: 'productDetailCode',
            searchType: 'goodsDetail',
            // fixed: 'left',
            required: true,
          },
          {
            field: 'contractQuantity',
            title: this.$t('contractAgency.productTab.contractQuantity'),
            width: 120,
            // fixed: 'left',
            editRender: {
              name: 'inputNumber',
            },
            max: 999999999.999,
            percision: 3,
            required: true,
          },
          {
            field: 'productUnitName',
            title: this.$t('contractAgency.productTab.unit'),
            required: true,
            width: 100,
            editRender: { name: 'ElInput' },
            disabled: true,
          },
          {
            field: 'storageName',
            title: this.$t('contractAgency.productTab.warehouse'),
            width: 120,
            editRender: { name: 'searchTable' },
            searchType: 'warehouseDirectDeliver',
            required: true,
            name: 'storageName',
            code: 'storageNo',
            getName: 'storageName',
            getCode: 'storageCode',
          },
          {
            title: this.$t('contractAgency.productTab.purchaseTitle'),
            children: [
              // 进项税
              {
                field: 'importNormalTariffRate',
                title: this.$t('salePurchase.table.importNormalTariffRate'),
                width: 120,
                max: 100,
                min: 0,
                precision: this.$globalVar.tPoint,
                // editRender: { name: "ElInput"},
                required: this.businessType == 'DLYW01',
                editRender: { name: 'inputNumber', type: 'default' },
              },
              // 税率
              {
                field: 'taxRatePurchase',
                title: this.$t('salePurchase.table.taxRate'),
                width: 120,
                // editRender: { name: "ElInput"},
                disabled: true,
                editRender: { name: 'default', type: 'default' },
              },
              // 采购  进项税码
              {
                field: 'purchaseTaxCode',
                title: this.$t('salePurchase.table.taxCode'),
                width: 120,
                editRender: { name: 'ajaxSelect', type: 'default' },
                apiUrl: BASE_API.QUERY_TAX_RATE,
                valueKey: 'taxCode',
                labelKey: 'taxName',
                valueType: '',
                name: 'purchaseTaxName',
                required: true,
              },
              {
                field: 'purchaseBusinessUnitPrice',
                title: this.$t('contractAgency.contractPrice'),
                width: 120,
                editRender: {
                  name: 'inputNumber',
                },
                max: '99999999999.999999',
                required: true,
                label: this.$t('contractAgency.productTab.originCoin'),
              },
              {
                field: 'purchaseBusinessTotalAmount',
                title: this.$t('contractAgency.productTab.businessTotalAmount'),
                width: 120,
                editRender: { name: 'inputNumber' },
                max: '99999999999.999999',
                precision: 2,
                required: true,
                label: this.$t('contractAgency.productTab.originCoin'),
              },
              {
                field: 'purchaseBusinessTaxAmount',
                title: this.$t('contractAgency.productTab.businessTaxAmount'),
                width: 120,
                editRender: {
                  name: 'inputNumber',
                },
                max: '99999999999.999999',
                required: true,
                disabled: true,
                label: this.$t('contractAgency.productTab.originCoin'),
              },
              {
                field: 'purchaseBusinessPureAmount',
                title: this.$t('contractAgency.productTab.businessPureAmount'),
                width: 120,
                editRender: { name: 'ElInput' },
                disabled: true,
                required: true,
                label: this.$t('contractAgency.productTab.originCoin'),
              },
              {
                field: 'purchaseReceivingWay',
                title: this.$t('contractAgency.getGoodWay'),
                width: 120,
                editRender: { name: 'ajaxSelect' },
                apiUrl: AGENCY_API.DICT_LIST,
                apiData: { dictType: 'instruction_type' },
                required: true,
                name: 'purchaseReceivingWayName',
                code: 'purchaseReceivingWay',
                valueType: 'object',
              },
              {
                field: 'purchaseDeliveryWay',
                title: this.$t('contractAgency.transportWay'),
                width: 120,
                editRender: { name: 'ajaxSelect' },
                apiUrl: AGENCY_API.DICT_LIST,
                apiData: { dictType: 'delivery_method' },
                required: true,
                name: 'purchaseDeliveryWayName',
                code: 'purchaseDeliveryWay',
                valueType: 'object',
              },
            ],
          },
          {
            title: this.$t('contractAgency.productTab.proxyBusinessTitle'),
            children: [
              // 退税
              {
                field: 'taxRefundRate',
                title: this.$t('salePurchase.table.taxRefundRate'),
                width: 120,
                max: 100,
                min: 0,
                precision: this.$globalVar.tPoint,
                // editRender: { name: "ElInput"},
                required: this.businessType == 'DLYW03',
                editRender: { name: 'inputNumber', type: 'default' },
              },
              // 税率
              {
                field: 'taxRateProxy',
                title: this.$t('salePurchase.table.taxRate'),
                width: 120,
                // editRender: { name: "ElInput"},
                disabled: true,
                editRender: { name: 'default', type: 'default' },
              },
              // 代理  销项税码
              {
                field: 'salesTaxCode',
                title: this.$t('salePurchase.table.taxCode'),
                width: 120,
                editRender: { name: 'ajaxSelect', type: 'default' },
                apiUrl: BASE_API.QUERY_TAX_RATE,
                valueKey: 'taxCode',
                labelKey: 'taxName',
                valueType: '',
                name: 'salesTaxName',
                required: true,
              },
              {
                field: 'proxyBusinessUnitPrice',
                title: this.$t('contractAgency.contractPrice'),
                width: 120,
                editRender: {
                  name: 'inputNumber',
                },
                max: '99999999999.999999',
                required: true,
                label: this.$t('contractAgency.productTab.originCoin'),
              },
              {
                field: 'proxyBusinessTotalAmount',
                title: this.$t('contractAgency.productTab.businessTotalAmount'),
                width: 120,
                editRender: { name: 'inputNumber' },
                max: '99999999999.999999',
                precision: 2,
                required: true,
                label: this.$t('contractAgency.productTab.originCoin'),
              },
              {
                field: 'proxyBusinessTaxAmount',
                title: this.$t('contractAgency.productTab.businessTaxAmount'),
                width: 120,
                editRender: {
                  name: 'inputNumber',
                },
                max: '99999999999.999999',
                disabled: true,
                required: true,
                label: this.$t('contractAgency.productTab.originCoin'),
              },
              {
                field: 'proxyBusinessPureAmount',
                title: this.$t('contractAgency.productTab.businessPureAmount'),
                width: 120,
                editRender: { name: 'ElInput' },
                disabled: true,
                required: true,
                label: this.$t('contractAgency.productTab.originCoin'),
              },
              {
                field: 'proxyDistributionWay',
                title: this.$t('contractAgency.shipWap'),
                width: 120,
                editRender: { name: 'ajaxSelect' },
                apiUrl: AGENCY_API.DICT_LIST,
                apiData: { dictType: 'sale_instruction_type', tenantCode },
                required: true,
                name: 'proxyDistributionWayName',
                code: 'proxyDistributionWay',
                valueType: 'object',
              },
              {
                field: 'proxyDeliveryWay',
                title: this.$t('contractAgency.transportWay'),
                width: 120,
                editRender: { name: 'ajaxSelect' },
                apiUrl: AGENCY_API.DICT_LIST,
                apiData: { dictType: 'delivery_method' },
                required: true,
                name: 'proxyDeliveryWayName',
                code: 'proxyDeliveryWay',
                valueType: 'object',
              },
            ],
          },
        ];
      },
      totalForm() {
        const total = this.allTotal;
        // const rate = this.exchangeRate;
        return [
          { title: this.$t('contractAgency.productTab.purchaseOriginCoin'), text: true }, // 采购合同价格原币
          {
            title: this.$t('contractAgency.productTab.businessTotalAmount'),
            value: spliceMoreZero(total.purchaseBusinessTotalAmount),
          },
          {
            title: this.$t('contractAgency.productTab.businessTaxAmount'),
            value: spliceMoreZero(total.purchaseBusinessTaxAmount),
          },
          {
            title: this.$t('contractAgency.productTab.businessPureAmount'),
            value: spliceMoreZero(total.purchaseBusinessPureAmount),
          },
          { title: this.$t('contractAgency.productTab.purchaseLocalCoin'), text: true }, // 采购合同价格本币
          {
            title: this.$t('contractAgency.productTab.businessTotalAmount'),
            value: spliceMoreZero(total.purchaseBusinessTotalAmountLocal),
          },
          {
            title: this.$t('contractAgency.productTab.businessTaxAmount'),
            value: spliceMoreZero(total.purchaseBusinessTaxAmountLocal),
          },
          {
            title: this.$t('contractAgency.productTab.businessPureAmount'),
            value: spliceMoreZero(total.purchaseBusinessPureAmountLocal),
          },
          { title: this.$t('contractAgency.productTab.proxyOriginCoin'), text: true }, // 代理合同价格原币
          {
            title: this.$t('contractAgency.productTab.businessTotalAmount'),
            value: spliceMoreZero(total.proxyBusinessTotalAmount),
          },
          {
            title: this.$t('contractAgency.productTab.businessTaxAmount'),
            value: spliceMoreZero(total.proxyBusinessTaxAmount),
          },
          {
            title: this.$t('contractAgency.productTab.businessPureAmount'),
            value: spliceMoreZero(total.proxyBusinessPureAmount),
          },
          { title: this.$t('contractAgency.productTab.proxyLocalCoin'), text: true }, // 代理合同价格本币
          {
            title: this.$t('contractAgency.productTab.businessTotalAmount'),
            value: spliceMoreZero(total.proxyBusinessTotalAmountLocal),
          },
          {
            title: this.$t('contractAgency.productTab.businessTaxAmount'),
            value: spliceMoreZero(total.proxyBusinessTaxAmountLocal),
          },
          {
            title: this.$t('contractAgency.productTab.businessPureAmount'),
            value: spliceMoreZero(total.proxyBusinessPureAmountLocal),
          },
        ];
      },
      // 校验规则
      editRules() {
        return this.getRules();
      },
      totalText() {
        return this.$t('contractAgency.productTab.totalText');
      },
      originCoin() {
        return this.$t('contractAgency.productTab.originCoin');
      },
      localCoin() {
        return this.$t('contractAgency.productTab.localCoin');
      },
    },
    mounted() {
      // 初始化表格是否编辑
      this.editConfig = this.isEdit ? { trigger: 'click', mode: 'row' } : {};
      this.showTable = false;
    },
    watch: {
      // 判断表格编辑功能是否禁用
      isEdit: function (newQuestion) {
        this.editConfig = newQuestion ? { trigger: 'click', mode: 'row' } : {};
      },
      defaultData() {
        this.initData();
        setTimeout(() => {
          this.editClosedEvent({}, true);
        }, 0);
      },
      exchangeRate() {
        //采购汇率
        // 汇率变化，重新计算表格 以及 合计数据
        // 小计：等表格数据加载完成后（初次）再获取合计
        setTimeout(() => {
          this.editClosedEvent({}, true);
        }, 0);
      },
      salesExchangeRate() {
        //
        // 汇率变化，重新计算表格 以及 合计数据
        // 小计：等表格数据加载完成后（初次）再获取合计
        setTimeout(() => {
          this.editClosedEvent({}, true);
        }, 0);
      },
      //业务性质改变
      defaultBusinessType(newValue) {
        this.businessType = newValue;
        setTimeout(() => {
          this.changeBusiness();
        }, 0);
      },
    },
    methods: {
      spliceMoreZero,
      toFixedNumber,
      initData() {
        const defaultData = Object.assign({}, this.defaultData);
        this.isExpand =
          ['', 'ZT02', 'ZT05', 'ZT06', 'ZT051', 'ZT061'].indexOf(defaultData.contractStatus) ==
            '-1' && defaultData.isFixedPrice == '1';
        this.showTable = true;
        this.productData = defaultData.orderTradeDetailList
          ? defaultData.orderTradeDetailList.slice()
          : [];
        delete defaultData.orderTradeDetailList;
        delete defaultData.attachmentList;
        delete defaultData.orderInterest;
        delete defaultData.orderDelivery;
        delete defaultData.orderContractRelationshipList;
        this.allTotal = defaultData;
        this.selectTotal = defaultData;
        this.$baseRequest.getTaxRate({}).then((result) => {
          this.addedTaxRateOptions = result;
          this.productData.forEach((item) => {
            if (item.purchaseTaxCode) {
              item.purchaseTaxName = this.addedTaxRateOptions.find((options) => {
                return item.purchaseTaxCode == options.taxCode;
              }).taxName;
            }
            if (item.salesTaxCode) {
              item.salesTaxName = this.addedTaxRateOptions.find((options) => {
                return item.salesTaxCode == options.taxCode;
              }).taxName;
            }
          });
        });
      },
      chooseTable(row, item, type) {
        if (item.field === 'productDesc') {
          // 将单位带出来
          const product = row[item.field] ? row[item.field][0] : null;
          if (this.businessType == 'DLYW03' || this.businessType == 'DLYW01') {
            if (product && (product.customsId == null || product.customsId == '')) {
              this.$refs.ruleTable.remove(row);
              //该商品没有海关信息请维护
              this.$message({
                type: 'error',
                message: '该商品没有海关信息请维护',
              });
              this.editClosedEvent({ row });
              return;
            }
          }
          if (product) {
            row.productUnit = product.basicUnit;
            row.productUnitName = product.basicUnitName;
            row.product = product;
            row.customsId = product.customsId;

            row.purchaseTaxCode = product.valueAddedTaxCode || null; //采购
            row.purchaseTaxName = product.valueAddedTaxCode
              ? this.addedTaxRateOptions.find((options) => {
                  return product.valueAddedTaxCode == options.taxCode;
                }).taxName
              : '';
            row.salesTaxCode = product.salesTaxCode || null; //销售 代理
            row.salesTaxName = product.salesTaxCode
              ? this.addedTaxRateOptions.find((options) => {
                  return product.salesTaxCode == options.taxCode;
                }).taxName
              : '';
            //taxRatePurchase 采购 taxRateProxy 税率_代理端
            row.taxRatePurchase = product.valueAddedTaxRate;
            row.taxRateProxy = product.salesTaxRate || 0;
            row.importNormalTariffRate = product.importNormalTariffRate || 0;
            row.taxRefundRate = product.taxRefundRate;
          }
        }
        //采购
        if (item.field == 'purchaseTaxCode') {
          const obj = this.addedTaxRateOptions.find((options) => {
            return row[item.field] == options.taxCode;
          });
          if (obj) {
            row.purchaseTaxName = obj.taxName;
            row.taxRatePurchase = obj.taxRate;
          }
        }
        //代理
        if (item.field == 'salesTaxCode') {
          const obj = this.addedTaxRateOptions.find((options) => {
            return row[item.field] == options.taxCode;
          });
          if (obj) {
            row.salesTaxName = obj.taxName;
            row.taxRateProxy = obj.taxRate;
          }
        }
        if (type === 'ajaxSelect' && item.valueType == 'object') {
          const data = row[item.field];
          row[item.name] = data.label;
          row[item.code] = data.value;
        }
        if (type == 'searchTable') {
          const obj = row[item.field][0];
          row[item.name] = obj[item.getName];
          row[item.code] = obj[item.getCode];
        }
        this.$refs.ruleTable.reloadRow(row);
      },
      //改变税率
      async changeBusiness() {
        let getTypeTableData = this.$refs.ruleTable.getTableData().fullData;
        // 转口 出口 进口 判断海关编码没有则不添加
        const removeList = [];
        if (this.businessType == 'DLYW03' || this.businessType == 'DLYW01') {
          for (let i = 0; i < getTypeTableData.length; i++) {
            if (getTypeTableData[i].customsId == null) {
              removeList.push(getTypeTableData[i]);
            }
          }
          //this.$refs.ruleTable.remove(removeList);
        }
        if (removeList.length > 0) {
          this.$message({
            type: 'error',
            message: `请维护商品的${this.businessType == 'DLYW03' ? '退税率' : '进口关税'}`,
          });
        }
        /* if(removeList.length>0){
        this.$message({
          type: "error",
          message: this.$t('goods.message.messageInfoCustoms')
        });
      } */
        //importNormalTariffRate  进口关税   valueAddedTaxRate 增值税率   taxRefundRate 退税率
        let getTableData = this.$refs.ruleTable.getTableData().fullData;
        for (let i = 0; i < getTableData.length; i++) {
          if (getTableData[i].productDesc) {
            getTableData[i].product = getTableData[i].product
              ? getTableData[i].product
              : await this.getStatusOptions(getTableData[i].productNo);
            const product = getTableData[i].product;
            const purchaseObj = this.addedTaxRateOptions.find((options) => {
              return getTableData[i].purchaseTaxCode == options.taxCode;
            });
            const salesObj = this.addedTaxRateOptions.find((options) => {
              return getTableData[i].salesTaxCode == options.taxCode;
            });
            getTableData[i].taxRatePurchase = purchaseObj.taxRate || 0;
            getTableData[i].taxRateProxy = salesObj.taxRate || 0;
            getTableData[i].importNormalTariffRate = product.importNormalTariffRate || 0;
            getTableData[i].taxRefundRate = product.taxRefundRate || 0;
          }
        }

        this.editClosedEvent({}, true);
      },
      //获取商品详细详情
      async getStatusOptions(productNo) {
        const params = {
          detailProductDisplayName: null,
          productDetailCode: productNo,
          pageSize: 10,
          pageNum: 1,
          //已生效
          detailProductStatus: 'ZT03',
          adminFlag: this.userInfo.adminFlag,
          selectCompanyCode: this.userInfo.companyCode,
        };
        const { data } = await this.$axios.post(BASE_API.LIST_DETAIL_PRODUCT, params);
        return data.data.list ? data.data.list[0] : [];
      },
      // 勾选时小计变化
      handleSelectionChange() {
        this.editClosedEvent({});
      },
      // 表尾合计
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.totalText;
            }
            if (columnIndex === 1) {
              return data.length;
            }
            const property = this.amountProps;
            const index = property.indexOf(column.property);
            if (index > -1) {
              if (
                this.selectTotal[property[index] + 'Local'] &&
                ['purchaseBusinessUnitPrice', 'proxyBusinessUnitPrice'].indexOf(property[index]) ==
                  -1
              ) {
                return (
                  this.originCoin +
                  '：' +
                  this.$baseRequest.formatTableColumn(
                    this.selectTotal[property[index]],
                    this.$globalVar.aPoint
                  ) +
                  ' ' +
                  this.localCoin +
                  ' ：' +
                  this.$baseRequest.formatTableColumn(
                    this.selectTotal[property[index] + 'Local'],
                    this.$globalVar.aPoint
                  )
                );
              } else if (
                this.selectTotal[property[index] + 'Local'] &&
                ['purchaseBusinessUnitPrice', 'proxyBusinessUnitPrice'].indexOf(property[index]) >
                  -1
              ) {
                return (
                  this.originCoin +
                  '：' +
                  this.$baseRequest.formatTableColumn(
                    this.selectTotal[property[index]],
                    this.$globalVar.pPoint
                  ) +
                  ' ' +
                  this.localCoin +
                  ' ：' +
                  this.$baseRequest.formatTableColumn(
                    this.selectTotal[property[index] + 'Local'],
                    this.$globalVar.pPoint
                  )
                );
              } else {
                if ('contractQuantity' == property[index]) {
                  return this.$baseRequest.formatTableColumn(
                    this.selectTotal[property[index]],
                    this.$globalVar.qPoint
                  );
                } else {
                  return this.$baseRequest.formatTableColumn(
                    this.selectTotal[property[index]],
                    this.$globalVar.aPoint
                  );
                }
              }
            }
            return '-';
          }),
        ];
      },
      getValues(select) {
        const selectedList = this.$refs['ruleTable'].getCheckboxRecords(); // 选中数据
        const allData = this.$refs['ruleTable'].getTableData();
        // 表格中填的数据
        const tableData = select && selectedList.length ? selectedList : allData.tableData;
        return tableData.map((item) => {
          const amountItem = {}; // 价格相关
          this.amountProps.forEach((key) => {
            amountItem[key] = item[key] || 0;
          });
          const result = Object.assign(
            {},
            item,
            {
              // contractDetailNo: index + 1,
            },
            amountItem
          );
          delete result.id;
          result.taxRateProxy = item.taxRateProxy ? item.taxRateProxy : 0;
          result.taxRatePurchase = item.taxRatePurchase ? item.taxRatePurchase : 0;
          return result;
        });
      },
      getTotal() {
        const allTotal = this.allTotal;
        // 只取有用的数据给后端，获取详情给这里时值很多
        const result = {};
        this.amountProps.forEach((key) => {
          if (allTotal[key]) {
            result[key] = allTotal[key];
          }
        });
        return result;
      },
      // 生成校验规则
      getRules() {
        const emptyTip = this.$t('contractAgency.productTab.emptyTip');
        const rules = {};
        function each(columns) {
          columns.forEach((item) => {
            if (item.required) {
              const message = item.title + emptyTip;
              rules[item.field] = [{ required: true, message: message }];
            }
            if (item.children && item.children.length) {
              each(item.children);
            }
          });
        }
        each(this.columns);
        return rules;
      },
      handleChangeInput({ row }, field) {
        //判断贸易合同生成的采销合同是否you后续业务
        let tempValue = this.defaultData.orderTradeDetailList
          ? this.defaultData.orderTradeDetailList.find(
              (it) => it.contractDetailNo == row.contractDetailNo
            )
          : null;
        if (tempValue !== null && tempValue !== undefined) {
          if (row.contractQuantity < tempValue.changeProductQuantity) {
            this.$message({
              type: 'error',
              message:
                this.$t('贸易合同相关联后续单据已发生业务,数量需大于等于') +
                tempValue.changeProductQuantity,
            });
            row.contractQuantity = tempValue.changeProductQuantity;
          }
        }
        // 税额小于价税合计金额
        if (row.purchaseBusinessTotalAmount && row.purchaseBusinessTaxAmount) {
          // 如果价税合计金额比税额小
          if (Number(row.purchaseBusinessTotalAmount) < Number(row.purchaseBusinessTaxAmount)) {
            row.purchaseBusinessTaxAmount = 0;
          }
        }
        if (row.proxyBusinessTotalAmount && row.proxyBusinessTaxAmount) {
          if (Number(row.proxyBusinessTotalAmount) < Number(row.proxyBusinessTaxAmount)) {
            row.proxyBusinessTaxAmount = 0;
          }
        }
        // 数量和其中一个单价存在才计算
        if (row.contractQuantity && (row.purchaseBusinessUnitPrice || row.proxyBusinessUnitPrice)) {
          //this.editClosedEvent({row});
        }
        this.editClosedSelfEvent({ row }, field);
      },
      // 每一行编辑状态关闭: 计算表格下方展示的总数
      editClosedEvent({ row = {} }, updateAll) {
        const rowIndex = this.$refs.ruleTable.$getRowIndex(row);
        const selectedOrderTradeDetailList = this.getValues(true);
        const allOrderTradeDetailList = this.getValues();
        const params = {
          contractCurrencyExchangeRate: this.exchangeRate || 0,
          salesCurrencyExchangeRate: this.salesExchangeRate || 0,
          selectedOrderTradeDetailListStr: JSON.stringify(selectedOrderTradeDetailList),
          allOrderTradeDetailListStr: JSON.stringify(allOrderTradeDetailList),
        };
        this.$axios.post(AGENCY_API.GET_ORDER_TOTAL, params).then((res) => {
          if (res.data.code == 0) {
            console.log('计算商品明细小计', res.data);
            const data = res.data.data;
            const allList = data.allList;
            this.allTotal = data.allTotal;
            this.selectTotal = data.selectTotal;
            // 单行计算本币
            if (row && row.contractQuantity) {
              // const rowData = allList ? allList[0] || {} : {};
              this.updateRow(row, allList[rowIndex], true);
            }
            // 更新所有行本币计算
            if (updateAll == true) {
              const productList = this.$refs['ruleTable'].getTableData().fullData;
              productList.forEach((item, index) => {
                if (item.contractQuantity) {
                  this.updateRow(item, allList[index]);
                }
              });
            }
            // 手动更新数据展示
            if (this.$refs['ruleTable']) {
              this.$refs['ruleTable'].updateFooter();
            }
          }
        });
      },
      //前台计算数据
      editClosedSelfEvent({ row }, field) {
        this.calcMoneyTrade(row, field, this.exchangeRate, this.salesExchangeRate);
        this.updateAllMoney(this.$refs.ruleTable.getTableData().fullData);
      },
      updateAllMoney: function (datas) {
        let purchaseBusinessTotalAmountTotal = 0;
        let purchaseBusinessTaxAmountTotal = 0;
        let purchaseBusinessPureAmountTotal = 0;
        let contractQuantity = 0;
        let purchaseBusinessUnitPriceTotal = 0;
        let proxyBusinessUnitPriceTotal = 0;
        let proxyBusinessTotalAmountTotal = 0;
        let proxyBusinessTaxAmountTotal = 0;
        let proxyBusinessPureAmountTotal = 0;

        let purchaseBusinessUnitPrice = 0;
        let purchaseBusinessUnitPriceLocal = 0;
        let proxyBusinessUnitPrice = 0;
        let proxyBusinessUnitPriceLocal = 0;
        let purchaseBusinessPureAmount = 0;
        let purchaseBusinessPureAmountLocal = 0;
        let purchaseBusinessTaxAmount = 0;
        let purchaseBusinessTaxAmountLocal = 0;
        let purchaseBusinessTotalAmount = 0;
        let purchaseBusinessTotalAmountLocal = 0;
        let proxyBusinessPureAmount = 0;
        let proxyBusinessPureAmountLocal = 0;
        let proxyBusinessTaxAmount = 0;
        let proxyBusinessTaxAmountLocal = 0;
        let proxyBusinessTotalAmount = 0;
        let proxyBusinessTotalAmountLocal = 0;
        let utilMethod = XEUtils;
        utilMethod.each(datas, (obj) => {
          purchaseBusinessTotalAmountTotal = this.$cal.calCommon(
            purchaseBusinessTotalAmountTotal,
            obj.purchaseBusinessTotalAmount,
            '+',
            'amount'
          );
          purchaseBusinessTaxAmountTotal = this.$cal.calCommon(
            purchaseBusinessTaxAmountTotal,
            obj.purchaseBusinessTaxAmount,
            '+',
            'amount'
          );
          purchaseBusinessPureAmountTotal = this.$cal.calCommon(
            purchaseBusinessPureAmountTotal,
            obj.purchaseBusinessPureAmount,
            '+',
            'amount'
          );
          proxyBusinessTotalAmountTotal = this.$cal.calCommon(
            proxyBusinessTotalAmountTotal,
            obj.proxyBusinessTotalAmount,
            '+',
            'amount'
          );
          proxyBusinessTaxAmountTotal = this.$cal.calCommon(
            proxyBusinessTaxAmountTotal,
            obj.proxyBusinessTaxAmount,
            '+',
            'amount'
          );
          proxyBusinessPureAmountTotal = this.$cal.calCommon(
            proxyBusinessPureAmountTotal,
            obj.proxyBusinessPureAmount,
            '+',
            'amount'
          );
          contractQuantity = this.$cal.calCommon(
            contractQuantity,
            obj.contractQuantity,
            '+',
            'quantity'
          );
          purchaseBusinessUnitPriceTotal = this.$cal.calCommon(
            purchaseBusinessUnitPriceTotal,
            obj.purchaseBusinessUnitPrice,
            '+',
            'quantity'
          );
          proxyBusinessUnitPriceTotal = this.$cal.calCommon(
            proxyBusinessUnitPriceTotal,
            obj.proxyBusinessUnitPrice,
            '+',
            'quantity'
          );
        });
        purchaseBusinessPureAmount = purchaseBusinessPureAmountTotal;
        purchaseBusinessPureAmountLocal = this.$cal.calCommon(
          purchaseBusinessPureAmount,
          this.exchangeRate,
          '+',
          'amount'
        );
        purchaseBusinessTaxAmount = purchaseBusinessTaxAmountTotal;
        purchaseBusinessTaxAmountLocal = this.$cal.calCommon(
          purchaseBusinessTaxAmount,
          this.exchangeRate,
          '*',
          'amount'
        );
        purchaseBusinessTotalAmount = purchaseBusinessTotalAmountTotal;
        purchaseBusinessTotalAmountLocal = this.$cal.calCommon(
          purchaseBusinessTotalAmount,
          this.exchangeRate,
          '*',
          'amount'
        );
        purchaseBusinessUnitPrice = purchaseBusinessUnitPriceTotal;
        purchaseBusinessUnitPriceLocal = this.$cal.calCommon(
          purchaseBusinessUnitPriceTotal,
          this.exchangeRate,
          '*',
          'amount'
        );

        proxyBusinessPureAmount = proxyBusinessPureAmountTotal;
        proxyBusinessPureAmountLocal = this.$cal.calCommon(
          proxyBusinessPureAmount,
          this.salesExchangeRate,
          '+',
          'amount'
        );
        proxyBusinessTaxAmount = proxyBusinessTaxAmountTotal;
        proxyBusinessTaxAmountLocal = this.$cal.calCommon(
          proxyBusinessTaxAmount,
          this.salesExchangeRate,
          '*',
          'amount'
        );
        proxyBusinessTotalAmount = proxyBusinessTotalAmountTotal;
        proxyBusinessTotalAmountLocal = this.$cal.calCommon(
          proxyBusinessTotalAmount,
          this.salesExchangeRate,
          '*',
          'amount'
        );
        proxyBusinessUnitPrice = proxyBusinessUnitPriceTotal;
        proxyBusinessUnitPriceLocal = this.$cal.calCommon(
          proxyBusinessUnitPriceTotal,
          this.salesExchangeRate,
          '*',
          'amount'
        );
        this.allTotal = {
          proxyBusinessPureAmount: purchaseBusinessPureAmount,
          proxyBusinessPureAmountLocal: proxyBusinessPureAmountLocal,
          proxyBusinessTaxAmount: proxyBusinessTaxAmount,
          proxyBusinessTaxAmountLocal: proxyBusinessTaxAmountLocal,
          proxyBusinessTotalAmount: proxyBusinessTotalAmount,
          proxyBusinessTotalAmountLocal: proxyBusinessTotalAmountLocal,
          purchaseBusinessPureAmount: purchaseBusinessPureAmount,
          purchaseBusinessPureAmountLocal: purchaseBusinessPureAmountLocal,
          purchaseBusinessTaxAmount: purchaseBusinessTaxAmount,
          purchaseBusinessTaxAmountLocal: purchaseBusinessTaxAmountLocal,
          purchaseBusinessTotalAmount: purchaseBusinessTotalAmount,
          purchaseBusinessTotalAmountLocal: purchaseBusinessTotalAmountLocal,
          contractQuantity: contractQuantity,
          proxyBusinessUnitPrice: proxyBusinessUnitPrice,
          proxyBusinessUnitPriceLocal: proxyBusinessUnitPriceLocal,
          purchaseBusinessUnitPrice: purchaseBusinessUnitPrice,
          purchaseBusinessUnitPriceLocal: purchaseBusinessUnitPriceLocal,
        };
        this.selectTotal = this.allTotal;
        // 手动更新表尾合计
        if (this.$refs.xTable) {
          this.$refs.xTable.updateFooter();
        }
      },
      updateRow(row, rowData, single) {
        this.amountProps.forEach((prop) => {
          if (rowData[prop]) {
            row[prop] = spliceMoreZero(rowData[prop]);
            row[prop + 'Local'] = spliceMoreZero(rowData[prop + 'Local']);
          }
        });
        if (single && this.$refs.ruleTable) {
          this.$refs.ruleTable.reloadRow(row);
        }
      },
      // 新增一行
      commitProxy() {
        // 调用vxe-grid新增方法  对行项目号进行单独赋值
        this.$refs.ruleTable.commitProxy('insert_actived');
        this.$refs.ruleTable.getTableData().fullData.map((item) => {
          if (!item.contractDetailNo) {
            item.checkFlag = true;
            item.contractDetailNo = this.$baseRequest.getNewDetailNo(
              this.$refs.ruleTable,
              'contractDetailNo'
            );
          }
        });
      },
      //删除一行
      handleDelete() {
        const selectedList = this.$refs['ruleTable'].getCheckboxRecords(); // 选中数据
        if (selectedList.length == 1) {
          let checkFlag = selectedList[0].checkFlag;
          if (!checkFlag) {
            this.$message({
              showClose: true,
              message: this.$t('xTable.disableDel'),
              type: 'error',
            });
            return;
          } else {
            this.$confirmAction()
              .then(() => {
                this.$refs['ruleTable'].removeSelecteds();
                this.$message({
                  showClose: true,
                  type: 'success',
                  message: this.$t('message.success'),
                });
                // 删除后重新计算总数
                this.editClosedEvent({});
              })
              .catch(() => {
                this.$message({
                  showClose: true,
                  type: 'info',
                  message: this.$t('message.cancle'),
                });
              });
          }
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.oneSelectData'),
            type: 'error',
          });
        }
      },
      //设置单元格样式
      setClassName({ column }) {
        if (column.property == 'productDesc') {
          // 代理不定价未勾选折叠样式不展示
          if (this.defaultData.isFixedPrice == '0') {
            return 'noExpandCell';
          }
        } else {
          // 非商品描述，这贴样式不展示
          return '';
        }
      },
      activeRowMethod({ row }) {
        return (
          row.priceIdentityName == '已定价' && row.isUsed != 1 && row.pricingStatusName != '审批中'
        );
      },
      // 展开行
      loadContentMethod({ row }) {
        const that = this;
        return new Promise((resolve) => {
          let childCols = [
            {
              field: 'productDesc',
              title: that.$t('salePurchase.price.productDesc'),
            },
            {
              field: 'productQuantity',
              title: that.$t('salePurchase.price.productQuantity'),
              //允许输入的最大值
              max: '99999999999',
              //保留几位小数
              precision: this.$globalVar.qPoint,
              editRender: { name: 'inputNumber', type: 'default' },
              showLimit: this.$globalVar.qPoint,
            },
            {
              field: 'productUnitName',
              title: that.$t('salePurchase.price.productUnit'),
            },
            {
              field: 'salesUnitPrice',
              title: that.$t('salePurchase.price.salesUnitPrice'),
            },
            {
              field: 'priceIdentityName',
              title: that.$t('salePurchase.price.priceIdentity'),
            },
            {
              field: 'pricingRuleName',
              title: that.$t('salePurchase.price.pricingRule'),
            },
            {
              field: 'temporaryPrice',
              title: that.$t('salePurchase.price.temporaryPrice'),
              //允许输入的最大值
              max: '99999999999.999999',
              //保留几位小数
              precision: this.$globalVar.pPoint,
              editRender: { name: 'inputNumber', type: 'default' },
              showLimit: this.$globalVar.aPoint,
            },
            {
              field: 'confirmDate',
              title: that.$t('salePurchase.price.confirmDate'),
            },
            {
              field: 'operatorName',
              title: that.$t('salePurchase.price.operatorName'),
            },
            {
              field: 'pricingStatusName',
              title: that.$t('salePurchase.price.pricingStatusName'),
            },
          ];
          let salseContractNo = '';
          this.defaultData.orderContractRelationshipList.map((item) => {
            if (item.relatedContractType == 'HT07') {
              salseContractNo = item.relatedContractNo;
            }
          });
          //获取点价详情
          this.$axios
            .post(AGENCY_API.GET_ORDERSALEDETAIL_API, {
              contractNo: salseContractNo,
              contractDetailNo: row.contractDetailNo,
              version: row.version,
            })
            .then((res) => {
              if (res.data.code === 0) {
                row.childCols = childCols;
                res.data.data.forEach((item) => {
                  item.productQuantity = spliceMoreZero(item.productQuantity);
                  item.productUnit = spliceMoreZero(item.productUnit);
                  item.contractDetailNo = row.contractDetailNo;
                  item.contractNo = row.contractNo;
                  item.temporaryPricebefore = item.temporaryPrice;
                  item.productQuantitybefore = item.productQuantity;
                  // item.isUsed = item.isUsed;
                });
                row.childData = res.data.data.filter((it) => it.productQuantity != 0);
                resolve();
              } else {
                that.$alert(res.data.msg);
              }
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .total-price {
    color: #444;
    font-size: 12px;
    margin-top: 20px;
    line-height: 32px;
    padding-left: 10px;
  }
  .price-col {
    line-height: 18px;
  }
  .childDataTable {
    width: 1000px !important;
  }
</style>
<style lang="scss">
  .agencyContract-table {
    .vxe-table--header {
      border-collapse: collapse;
    }
    th.vxe-header--column {
      border: 1px solid #cdc9c9 !important;
    }
  }
</style>
<style lang="scss">
  .noExpandCell .vxe-table--expanded {
    display: none;
  }
</style>
